import React, { useEffect } from "react";

// w/o a fetchMore function this is essentially a noop
const useInfiniteScroll = (fetchMore, element = {}) => {
  const isEmptyElement = !element || Object.keys(element).length === 0;
  const isEndOfScroll = ({ scrollTop, clientHeight, scrollHeight }) => {
    return Math.round(scrollTop) + clientHeight >= scrollHeight;
  };

  const scroll = () => {
    if (!isEmptyElement && isEndOfScroll(element)) {
      fetchMore();
    }
  };

  useEffect(() => {
    if (isEmptyElement || typeof fetchMore !== "function") return;
    element.addEventListener("scroll", scroll);
    return () => {
      element.removeEventListener("scroll", scroll);
    };
  }, [element, scroll, fetchMore, isEmptyElement]);
};

export default useInfiniteScroll;
